import FetchApi from "../../core/fetch-api";

export const getKpiData = async (callback, openSnackBar) => {
    const response = await FetchApi.requestCustom('get', '/kpis', openSnackBar)
    callback(response.results)
};